// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__RA8iN","social_cont":"Footer_social_cont__IyHEw","social_link":"Footer_social_link__JEvU4","footerLogo":"Footer_footerLogo__gqIlJ"};